export default "__VITE_ASSET__apSoQjAj__"